import { render, staticRenderFns } from "./GroupCallButton.vue?vue&type=template&id=384c35f3"
import script from "./GroupCallButton.vue?vue&type=script&lang=js"
export * from "./GroupCallButton.vue?vue&type=script&lang=js"
import style0 from "./GroupCallButton.vue?vue&type=style&index=0&id=384c35f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports